import React, { Suspense, component } from "react";

import ContainerPelayanan from "./view/pelayanan/ContainerPelayanan";
import ContainerPelayananRanap from "./view/pelayanan_ranap/ContainerPelayananRanap";
import PelayananObat from "../src/view/pelayananObat/ContainerPelayanan";
import Payments from "./view/payments/Payment_list";

import Umum from "./view/umum/umum";
import Kklp from "./view/kklp/umum";
import Gigi from "./view/gigi/Gigi";
import History from "./view/history/HistoryGroup";
import IhsHistory from "./view/ihs/History";

import Perawat from "./view/keperawatan/Keperawatan";
import FormSehat from "./view/medicalCertificate/FormSehat";
import Sickness from "./view/medical/Sickness";
import FormPeriksa from "./view/surat_periksa/FormPeriksa";
import FormButaWarna from "./view/surat_buta_warna/FormButaWarna";
import FormUploadImage from "./view/upload_image/FormUploadImage";
import RawatInap from "./view/rawat_inap/RawatInap";
import PermintaanLab from "./view/lab/PermintaanLab";
import PemeriksaanLab from "./view/lab/PemeriksaanLab";
import Resep from "../src/view/pelayananObat/resep/resep";
import DrugInformation from "../src/view/pelayananObat/DrugInformation";
import DrugCounseling from "../src/view/pelayananObat/DrugCounseling";
import Resume from "../src/view/resume/Resume";
import HistoryRanap from "./view/history_ranap/HistoryRanap";
import KB from "../src/view/kb/Kb";
import KbUlang from "../src/view/kb_ulang/KbUlang";
import Caten from "../src/view/caten/Caten";
import SPM from "../src/view/spm/SPM";
import Mtbs from "view/kia/mtbs";
import PregnantHistory from "view/kia/PregnantHistory";
import Pregnant from "view/kia/Pregnant";
import Immunization from "view/kia/Immunization";
import Igd from "view/igd/Igd";
import Gizi from "view/gizi/Gizi";
import Sdidtk from "view/kia/Immunization/Sdidtk";
import GrafikTumbuhKembang from "view/resume/GrafikTumbuhKembang";
import ImmunizationHistory from "view/immunizationHistory/ImmunizationHistory";
import Pedigree from "view/pedigree/index";
import KajianAwal from "view/kajian-awal/index";
import KajianAwalPerawat from "view/kajian-awal/KajianAwalPerawat";
import ApprovalLab from "view/lab/ApprovalLab";
import MonitoringKehamilan from "view/laporan/MonitoringKehamilan";

// import Listrujukan from "view/sisroute/Listrujukan";
// import Grafik from "view/iks/grafik/Grafik";
import ReportType from "./view/management/reportType/ReportType";
import ClinicTreatment from "./view/management/clinicTreatment/ClinicTreatment";
import ManagementProlanis from "./view/management/prolanis";
// import ImportData from "view/dinas/vaksin/ImportData/ImportData";
import ImportDataVaksin from "view/dinas/vaksin/ImportData/ImportData";
// import Jadwal from 'view/dinas/pirt/jadwal/refJadwal';

// import RekapLab from "view/laporan/laborat/RekapLab";
import kesehatanLingkungan from "view/kesehatanLingkungan";
import sanitasi from "view/sanitasi";
import PengawasanObatApotik from "view/dinas/farmakmin/PengawasanObatApotik";
import KkkPuskesmas from "view/kkk/Kkk_puskesmas";
import Role from "./view/role/Role";
import RoleAccess from "./view/role_access/Role";
import Location from "./view/location/Location";
import ClinicModule from "./view/clinic_module/ClinicModule";
import AnalisisTb from "view/dinas/TB/AnalisisTb";
import VerifLab from "view/odha/verifikasiHasil/VerifLab";
import ImportDataTb from "view/dinas/TB/importData/ImportDataTb2";
import Psikologi from "./view/psikologi/Psikologi";
import Sanitasi from "view/sanitasi_new/Sanitasi";
import Kulit from "view/kulit/Kulit";
import Ds from "view/hipertensi_dm/dashboard/Ds";
import Ilp from "view/ilp/ilp";
import ReportIlp from "view/ilp/report/ReportIlp";
import ReportIlpCount from "view/ilp/report/reportCount/ReportIlpCount";
import IlpDashboard from "view/dashboard_ilp/ilp_dashboard";
import Skdr from "view/laporan/skdr/Skdr";

const Home = React.lazy(() => import("./template/HomeContainer"));
// const Home = React.lazy(() => import("./template/Home"));
const Pendaftaran = React.lazy(() => import("./view/pendaftaran/Pendaftaran"));
const PendaftaranSimple = React.lazy(() =>
  import("./view/pendaftaran/PendaftaranSimple")
);
const PendaftaranRanap = React.lazy(() =>
  import("./view/pendaftaran_ranap/PendaftaranRanap")
);
// const Prolanis = React.lazy(() => import ('./view/prolanis/Prolanis'));
const ImportDataFlags = React.lazy(() =>
  import("./view/hipertensi_dm/importFlag")
);
const VisitSensus = React.lazy(() =>
  import("./view/laporan/visit_sensus/VisitSensus")
);
const KunjunganPasien = React.lazy(() =>
  import("./view/laporan/kunjungan_pasien/KunjunganPasien")
);

const KunjunganPasienByDX = React.lazy(() =>
  import("./view/laporan/kunjungan_pasien_byname/KunjunganPasien")
);

const KunjunganPasienByIcd = React.lazy(() =>
  import("./view/laporan/kunjungan_pasien_byicd/KunjunganPasien")
);

const MonitoringKunjunganPasienByIcd = React.lazy(() =>
  import("./view/laporan/monitoring_by_icd/KunjunganPasien")
);

const MonitoringLostKunjunganPasien = React.lazy(() =>
  import("./view/hipertensi_dm/lost_visit/KunjunganPasien")
);

const KunjunganPasienProhits = React.lazy(() =>
  import("./view/hipertensi_dm/prohits/KunjunganPasien")
);

const LaporanOverdue = React.lazy(() =>
  import("./view/laporan/overdue/KunjunganPasien")
);

const SepuluhBesar = React.lazy(() =>
  import("./view/laporan/sepuluh_besar/SepuluhBesar")
);
const LB1 = React.lazy(() => import("./view/laporan/lb1/LB1"));
const LB4 = React.lazy(() => import("./view/laporan/lb4/LB4"));
const Kasir = React.lazy(() => import("./view/laporan/kasir/Kasir"));
const SensusLab = React.lazy(() => import("./view/laporan/laborat/RekapLab"));
const RekapLab = React.lazy(() => import("./view/laporan/laborat/CountRekap"));
const RekapLabHeader = React.lazy(() =>
  import("./view/laporan/laborat/CountRekapHeader")
);
const LaporanTindakan = React.lazy(() =>
  import("./view/laporan/tindakan/LaporanTindakan")
);
const LaporanMjkn = React.lazy(() => import("./view/laporan/mjkn/rekapMjkn"));
const PcareList = React.lazy(() => import("./view/pcare/Pending_list"));
const SatuSehatList = React.lazy(() =>
  import("./view/satu-sehat/SatuSehatList")
);
const VaksinApproval = React.lazy(() => import("./view/dinas/vaksin"));
const Profile = React.lazy(() => import("./view/profile/profile"));
const User = React.lazy(() => import("./view/user/User"));
const UserProfile = React.lazy(() => import("./view/userProfile/userProfile"));
// const PelayananObat = React.lazy(() => import("../src/view/pelayananObat/ContainerPelayanan"));
const KelompokPenyakit = React.lazy(() =>
  import("./view/kelompok_penyakit/KelompokPenyakit")
);
const ResepHarian = React.lazy(() =>
  import("./view/pelayananObat/obatHarian/rekapHarian")
);
const DrugApproval = React.lazy(() =>
  import("./view/pelayananObat/penerimaanObat/Approval")
);
const LaporanPenerimaanObat = React.lazy(() =>
  import("./view/pelayananObat/laporan/LaporanPenerimaanObat")
);
const LaporanRekonsiliasiObat = React.lazy(() =>
  import("./view/pelayananObat/laporan/LaporanRekonsiliasiObat")
);
const LaporanPenggunaanObat = React.lazy(() =>
  import("./view/pelayananObat/laporan/LaporanPenggunaanObat")
);
const LaporanPenggunaanObatPasien = React.lazy(() =>
  import("./view/pelayananObat/laporan/LaporanPenggunaanObatPasien")
);
const ImportTfu = React.lazy(() => import("./view/dinas/kesling/Tfu"));

const ImportTpm = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/ImportTpm")
);
const ImportBlud = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/InputBlud")
);
const KesgaAdmin = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/KesgaAdmin")
);
const InputCapaianSPM = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/InputCapaianSPM")
);
const InputSPA = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/InputSPA")
);
const InputSDMK = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/InputSDMK")
);
const ImportPHBSSekolah = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/ImportPHBSSekolah")
);
const ImportPosyandu = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/ImportPosyandu")
);
const InputPromkesOlahraga = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/InputPromkesOlahraga")
);
const ImportProgkes = React.lazy(() =>
  import("./view/dinas/dashboardAanalytic/ImportProgkes")
);
const Admin = React.lazy(() => import("./view/dinas/admin"));
const PIRT = React.lazy(() => import("./view/dinas/pirt"));
const LaporanPermohonan = React.lazy(() => import("./view/dinas/laporan"));
const PemberianObatDinas = React.lazy(() =>
  import("./view/dinas/farmasi/PemberianObat")
);
const ListPemberianObat = React.lazy(() =>
  import("./view/dinas/farmasi/listPemberianObat")
);
const Payments_report = React.lazy(() =>
  import("./view/laporan/report_payments")
);
const Lplpo = React.lazy(() => import("./view/pelayananObat/laporan/Lplpo"));
const PelayananSBBK = React.lazy(() =>
  import("./view/pelayananObat/penerimaanSBBK/sbbk")
);
const PengadaanObat = React.lazy(() =>
  import("./view/pelayananObat/pengadaanObat")
);
const AdminScreening = React.lazy(() => import("./view/screening/admin"));
const Queue = React.lazy(() => import("./view/management/Queue"));
const RefIcd = React.lazy(() => import("./view/management/icd"));
const StockOpname = React.lazy(() =>
  import("./view/pelayananObat/stockOpname/stockOpname")
);
const TransferPeriodeStok = React.lazy(() =>
  import("./view/pelayananObat/transferPeriodeStok/transferPeriodeStok")
);
const TransferStokPoli = React.lazy(() =>
  import("./view/pelayananObat/transferStokPoli/transferStokPoli")
);
const LaporanTransferStock = React.lazy(() =>
  import("./view/pelayananObat/transferStokPoli/LaporanTransferStock")
);
const PioKonseling = React.lazy(() =>
  import("./view/pelayananObat/laporan/PioKonseling")
);
const RefTreatments = React.lazy(() => import("./view/management/treatment"));
const RefDrugs = React.lazy(() => import("./view/management/drug"));
const RefNinecm = React.lazy(() => import("./view/management/ninecm"));
const RefClinic = React.lazy(() => import("./view/management/clinic"));

const EditPasien = React.lazy(() => import("./view/management/pasien"));
const Jadwal = React.lazy(() => import("./view/dinas/pirt/jadwal/refJadwal"));
const Materi = React.lazy(() => import("./view/dinas/pirt/refMateri"));
const InputMasterPirt = React.lazy(() =>
  import("./view/dinas/pirt/inputMaster")
);
const Iks = React.lazy(() => import("./view/iks"));
const GrafikIks = React.lazy(() => import("./view/iks/grafik/Grafik"));
const Indikator = React.lazy(() => import("./view/iks/grafik/Indikator"));
const IndikatorByYerars = React.lazy(() => import("./view/iks/grafik/ByTahun"));
const DashboardVaksin = React.lazy(() =>
  import("./view/dinas/vaksin/dashboard")
);
const ImportData = React.lazy(() =>
  import("./view/dinas/iks/ImportData/ImportData")
);
const Listrujukan = React.lazy(() => import("./view/sisroute/Listrujukan"));

// const Payments = React.lazy(() => import ('./view/payments/Payment_list'));
const LaporanSanitasi = React.lazy(() => import("./view/laporan/sanitasi"));
const LaporanKesehatanLingkungan = React.lazy(() =>
  import("./view/laporan/kesehatanLingkungan")
);
const LaporanMatahati = React.lazy(() =>
  import("./view/laporan/laporan_matahati")
);
const QuestionScenearioKK = React.lazy(() =>
  import("./view/iks/grafik/QuestionScenearioKK")
);
const PerubahanDataIks = React.lazy(() =>
  import("./view/iks/PerubahanDataIks")
);
const PengawasanPirt = React.lazy(() =>
  import("./view/dinas/farmakmin/PengawasanPirt")
);
const UserLog = React.lazy(() => import("./view/userLog/index"));
const DBD = React.lazy(() => import("./view/tb/DBD"));
const MapDBD = React.lazy(() => import("./view/tb/MapDBD"));

/**
 * Ini adalah Object untuk menyimpan route dan Component
 */

const routes = [
  {
    path: "/ilp-dashboard",
    name: "Dashboard Ilp",
    icon: "ni ni-tv-2 text-primary",
    component: () => (
      <Suspense fallback={<div></div>}>
        <IlpDashboard />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/home",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: () => (
      <Suspense fallback={<div></div>}>
        <Home />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/adm-screening",
    name: "adm-screening",
    icon: "ni ni-tv-2 text-primary",
    component: () => (
      <Suspense fallback={<div></div>}>
        <AdminScreening />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/pendaftaran",
    name: "Pendaftaran",
    icon: "ni ni-folder-17 text-green",
    layout: "/admin",
    place: "navbar",
    child: [
      {
        path: "/pendaftaran",
        name: "Pendaftaran Rawat Jalan",
        icon: "ni ni-folder-17 text-green",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Pendaftaran />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/pendaftaran-ranap",
        name: "Pendaftaran Rawat Inap",
        icon: "ni ni-folder-17 text-green",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PendaftaranRanap />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/pendaftaran-simple",
        name: "Pendaftaran Pasien",
        icon: "ni ni-folder-17 text-green",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PendaftaranSimple />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
  },
  {
    path: "/pelayanan",
    name: "Pelayanan",
    icon: "ni ni-single-02 text-blue",
    layout: "/admin",
    place: "navbar",
    child: [
      {
        path: "/pelayanan",
        name: "Pelayanan Rawat Jalan",
        icon: "ni ni-folder-17 text-green",
        component: ContainerPelayanan,
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/pelayanan-ranap",
        name: "Pelayanan Rawat Inap",
        icon: "ni ni-folder-17 text-green",
        component: ContainerPelayananRanap,
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/verif-lab",
        name: "Odha",
        icon: "ni ni-folder-17 text-green",
        component: VerifLab,
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/approval-lab",
        name: "Approval Lab",
        icon: "ni ni-folder-17 text-green",
        component: ApprovalLab,
        layout: "/admin",
        place: "navbar",
      },
    ],
  },
  {
    path: "/Farmasi",
    name: "Farmasi",
    icon: "fas fa-capsules text-red",
    child: [
      {
        path: "/PelayananObatList",
        name: "Pelayanan Obat",
        icon: "ni ni-circle-08 text-pink",
        component: PelayananObat,
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/RekapHarianObat",
        name: "Input obat Harian",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ResepHarian />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/penerimaan_obat",
        name: "Penerimaan Obat",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <DrugApproval />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/Lplpo",
        name: "LPLPO",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Lplpo />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/stock_opname",
        name: "Stok Opname",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <StockOpname />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/penerimaan-obat-sbbk",
        name: "Penerimaan Obat SBBK",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PelayananSBBK />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/pengadaan-obat-mandiri",
        name: "Pengadaan Obat Mandiri",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PengadaanObat />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/transfer-periode-stok",
        name: "Transfer Periode Stok",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <TransferPeriodeStok />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/transfer-stok-poli",
        name: "Transfer Stok Poli",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <TransferStokPoli />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan-transfer-stok",
        name: "Laporan Transfer Stok",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanTransferStock />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/pio-konseling",
        name: "Laporan PIO dan Konseling",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PioKonseling />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_penerimaan_obat",
        name: "Laporan Penerimaan Obat",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanPenerimaanObat />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_rekonsiliasi_obat",
        name: "Laporan Rekonsiliasi Obat",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanRekonsiliasiObat />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_penggunaan_obat",
        name: "Laporan Penggunaan Obat",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanPenggunaanObat />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_penggunaan_obat_pasien",
        name: "Laporan Penggunaan Obat Pasien",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanPenggunaanObatPasien />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/iks",
    name: "IKS",
    icon: "ni ni-settings text-green",
    child: [
      {
        path: "/input-iks",
        name: "Input iks",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Iks />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/grafik-iks",
        name: "Grafik iks",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <GrafikIks />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/grafik-indictaor",
        name: "Grafik IKS Indicator",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Indikator />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/grafik-indicator-year",
        name: "IKS Indicator By jiwa",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <IndikatorByYerars />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/qs-indicator-kk",
        name: "IKS Indicator By kk",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <QuestionScenearioKK />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/perubahan-data",
        name: "Perubahan Data",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PerubahanDataIks />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
  {
    icon: "ni ni-collection text-info",
    name: "Kasir",
    path: "/cashier",
    child: [
      {
        path: "/payments",
        name: "Tagihan Pasien",
        component: Payments,
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/report_patments",
        name: "Laporan Tagihan",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Payments_report />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
  {
    icon: "ni ni-collection text-info",
    name: "Laporan",
    path: "/laporan",
    child: [
      {
        path: "/laporan_kunjungan_pasien",
        name: "Kunjungan Pasien",
        component: () => (
          <Suspense fallback={<div></div>}>
            <KunjunganPasien />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_pasien_diagnosa",
        name: "Kunjungan Pasien Berdasar Diagnosa",
        component: () => (
          <Suspense fallback={<div></div>}>
            <KunjunganPasienByDX />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_pasien_icd",
        name: "Rekap Kunjungan Pasien Diagnosa",
        component: () => (
          <Suspense fallback={<div></div>}>
            <KunjunganPasienByIcd />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      // {
      //   path: "/monitoring_by_icd",
      //   name: "Monitoring Kunjungan Pasien",
      //   component: () => (
      //     <Suspense fallback={<div></div>}>
      //       <MonitoringKunjunganPasienByIcd />
      //     </Suspense>
      //   ),
      //   layout: "/admin",
      //   place: "navbar",
      // },
      {
        path: "/laporan_visit_sensus",
        name: "Visit Sensus",
        component: () => (
          <Suspense fallback={<div></div>}>
            <VisitSensus />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_sepuluh_besar",
        name: "Sepuluh Besar",
        component: () => (
          <Suspense fallback={<div></div>}>
            <SepuluhBesar />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/lb1",
        name: "LB1",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LB1 />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/lb4",
        name: "LB4",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LB4 />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/sensusLab",
        name: "Laporan Sensus Lab",
        component: () => (
          <Suspense fallback={<div></div>}>
            <SensusLab />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/rekapLab",
        name: "Laporan Lab Harian",
        component: () => (
          <Suspense fallback={<div></div>}>
            <RekapLab />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/rekapLabHeader",
        name: "Laporan Lab Harian Header",
        component: () => (
          <Suspense fallback={<div></div>}>
            <RekapLabHeader />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/tindakan",
        name: "Laporan Tindakan",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanTindakan />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporanKasir",
        name: "Laporan Kasir",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Kasir />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan-sanitasi",
        name: "Laporan Sanitasi",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanSanitasi />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan-kesehatan-lingkungan",
        name: "Laporan Kesehatan Lingkungan",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanKesehatanLingkungan />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/monitoring-kehamilan",
        name: "Laporan Monitoring Kehamilan",
        component: () => (
          <Suspense fallback={<div></div>}>
            <MonitoringKehamilan />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan-mjkn",
        name: "Laporan Rekap Mjkn",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanMjkn />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan-matahati",
        name: "Laporan Matahati",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanMatahati />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/skdr",
        name: "Skdr",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Skdr />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },

  {
    path: "/pcare",
    name: "Log Pcare",
    icon: "ni ni-circle-08 text-pink",
    component: () => (
      <Suspense fallback={<div></div>}>
        <PcareList />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/satu-sehat",
    name: "Log Satu Sehat",
    icon: "ni ni-circle-08 text-pink",
    component: () => (
      <Suspense fallback={<div></div>}>
        <SatuSehatList />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/farmasi",
    name: "Farmasi Dinas",
    icon: "fas fa-capsules text-red",
    child: [
      {
        path: "/PemberianObat",
        name: "Pemberian Obat",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PemberianObatDinas />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/AntrianObat",
        name: "List Pemberian Obat",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ListPemberianObat />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/manData",
    name: "Manajemen",
    icon: "ni ni-single-copy-04 text-info",
    child: [
      {
        path: "/pasien",
        name: "pasien",
        component: () => (
          <Suspense fallback={<div></div>}>
            <EditPasien />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/user",
        name: "user",
        component: () => (
          <Suspense fallback={<div></div>}>
            <User />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/kelompok_penyakit",
        name: "Kelompok Penyakit",
        component: () => (
          <Suspense fallback={<div></div>}>
            <KelompokPenyakit />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/antrian",
        name: "antrian",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Queue />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/ref_icd",
        name: "ref_icd",
        component: () => (
          <Suspense fallback={<div></div>}>
            <RefIcd />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/treatment",
        name: "Tindakan",
        component: () => (
          <Suspense fallback={<div></div>}>
            <RefTreatments />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/drug",
        name: "Obat",
        component: () => (
          <Suspense fallback={<div></div>}>
            <RefDrugs />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/ninecm",
        name: "ninecm",
        component: () => (
          <Suspense fallback={<div></div>}>
            <RefNinecm />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/report-type",
        name: "Report Type",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ReportType />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/clinic",
        name: "Poli",
        component: () => (
          <Suspense fallback={<div></div>}>
            <RefClinic />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/clinic-treatment",
        name: "Kelompok Tindakan",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ClinicTreatment />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/prolanis",
        name: "Prolanis",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ManagementProlanis />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/log-user",
        name: "User Log",
        component: () => (
          <Suspense fallback={<div></div>}>
            <UserLog />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/role",
        name: "Role",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Role />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/role-access",
        name: "Role Access",
        component: () => (
          <Suspense fallback={<div></div>}>
            <RoleAccess />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/clinic-module",
        name: "Clinic Module",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ClinicModule />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/location",
        name: "Location",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Location />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/setting",
    name: "Setting",
    icon: "ni ni-settings text-green",
    child: [
      {
        path: "/profile",
        name: "Profile",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Profile />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/profil",
    name: "profil",
    icon: "ni ni-tv-2 text-primary",
    component: () => (
      <Suspense fallback={<div></div>}>
        <UserProfile />
      </Suspense>
    ),
    layout: "/admin",
    place: "/profil",
  },
  {
    path: "/pengajuan",
    name: "Admin Dinkes",
    icon: "ni ni-tv-2 text-primary",
    component: () => (
      <Suspense fallback={<div></div>}>
        <Admin />
      </Suspense>
    ),
    child: [
      {
        path: "/pengajuan",
        name: "Pengajuan Izin",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Admin />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_permohonan",
        name: "Laporan Permohonan Izin",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanPermohonan />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/pirt",
        name: "PIRT",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PIRT />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/jadwalPirt",
        name: "Set Jadwal PKP",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Jadwal />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/materiPKP",
        name: "Set Materi PKP",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Materi />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/inputMasterPirt",
        name: "Input Data Master",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <InputMasterPirt />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },

  {
    path: "/dashboardAnalytic",
    name: "Dashboard Analytic",
    icon: "ni ni-circle-08 text-default",
    component: () => (
      <Suspense fallback={<div></div>}>
        <ImportDataVaksin />
      </Suspense>
    ),
    child: [
      {
        path: "/imoprt-data-tb",
        name: "Import Data TB",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ImportDataTb />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/import-tpm",
        name: "Import TPP Siap Saji",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ImportTpm />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/tb-analitic",
        name: "Analisis Spasial TB",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <AnalisisTb />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/import-post-market",
        name: "Import Pengawasan Post Market",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PengawasanPirt />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/kesga-admin",
        name: "Kesga",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <KesgaAdmin />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/input-spm",
        name: "Input Capaian SPM",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <InputCapaianSPM />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/input-spa",
        name: "Import Sarana Prasarana dan Alkes (SPA)",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <InputSPA />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/input-blud",
        name: "Import Realisasi dan Belanja",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ImportBlud />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/import-obat-apotik",
        name: "Import Pengawasan Saryanfar",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <PengawasanObatApotik />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/input-sdmk",
        name: "Import SDMK",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <InputSDMK />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/kkk",
        name: "KKK Puskesmas",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <KkkPuskesmas />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/import-phbs-sekolah",
        name: "Import PHBS Sekolah",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ImportPHBSSekolah />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/import-posyandu",
        name: "Import Posyandu",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ImportPosyandu />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/promkes-olahraga",
        name: "ProgKes Olahraga",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <InputPromkesOlahraga />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/imoprt-data-tb",
        name: "Import Data TB",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ImportDataTb />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/imoprt-data-tfu",
        name: "Import Tfu",
        icon: "ni ni-tv-2 text-primary",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ImportTfu />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/importDataVaksin",
    name: "Import Data Vaksinasi",
    icon: "ni ni-circle-08 text-default",
    component: () => (
      <Suspense fallback={<div></div>}>
        <ImportDataVaksin />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/importDataIks",
    name: "Import Data IKS",
    icon: "ni ni-circle-08 text-default",
    component: () => (
      <Suspense fallback={<div></div>}>
        <ImportData />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/approvalVaksin",
    name: "Vaksinasi",
    icon: "ni ni-circle-08 text-default",
    component: () => (
      <Suspense fallback={<div></div>}>
        <VaksinApproval />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/dashboardVaksin",
    name: "Dashboard Vaksin",
    icon: "ni ni-circle-08 text-default",
    component: () => (
      <Suspense fallback={<div></div>}>
        <DashboardVaksin />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/refPcare",
    name: "referensi Pcare",
    icon: "ni ni-settings text-green",
    child: [],
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/layanan-spm",
    name: "Layanan SPM",
    icon: "ni ni-settings text-green",
    child: [
      {
        path: "/ds_ht_spm",
        name: "Dashboard SPM",
        icon: "ni ni-circle-08 text-default",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Ds />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/spm_ht_dm",
        name: "Import Sasaran SPM",
        icon: "ni ni-circle-08 text-default",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ImportDataFlags />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/monitoring_by_icd",
        name: "Monitoring Kunjungan Pasien",
        component: () => (
          <Suspense fallback={<div></div>}>
            <MonitoringKunjunganPasienByIcd />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/monitoring_lost_visit",
        name: "Monitoring Lost Visit",
        component: () => (
          <Suspense fallback={<div></div>}>
            <MonitoringLostKunjunganPasien />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_prohits",
        name: "Laporan Protokol Hipertensi",
        component: () => (
          <Suspense fallback={<div></div>}>
            <KunjunganPasienProhits />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/laporan_overdue",
        name: "Laporan Overdue",
        component: () => (
          <Suspense fallback={<div></div>}>
            <LaporanOverdue />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/dbd",
    name: "Import DBD",
    icon: "ni ni-settings text-green",
    component: () => (
      <Suspense fallback={<div></div>}>
        <DBD />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/map-dbd",
    name: "Peta DBD",
    icon: "ni ni-settings text-green",
    component: () => (
      <Suspense fallback={<div></div>}>
        <MapDBD />
      </Suspense>
    ),
    layout: "/admin",
    place: "navbar",
  },
  // {
  //   path: "/sisroute_list",
  //   name: "Sisroute",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: () => (
  //     <Suspense fallback={<div></div>}>
  //       <Listrujukan />
  //     </Suspense>
  //   ),
  //   layout: "/admin",
  //   place: "navbar",
  // },
  {
    path: "/Sisroute",
    name: "Sisroute",
    icon: "ni ni-settings text-green",
    child: [
      {
        path: "/list_rujukan",
        name: "Rujukan Masuk",
        icon: "ni ni-circle-08 text-pink",
        component: () => (
          <Suspense fallback={<div></div>}>
            <Listrujukan />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
  {
    path: "/layanan-ilp",
    name: "ILP",
    icon: "ni ni-settings text-green",
    child: [
      {
        path: "/report-ilp",
        name: "Report ILP",
        icon: "ni ni-circle-08 text-default",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ReportIlp />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
      {
        path: "/rekap-report-ilp",
        name: "Rekap Laporan ILP",
        icon: "ni ni-circle-08 text-default",
        component: () => (
          <Suspense fallback={<div></div>}>
            <ReportIlpCount />
          </Suspense>
        ),
        layout: "/admin",
        place: "navbar",
      },
    ],
    layout: "/admin",
    place: "navbar",
  },
];

const modules = [
  {
    path: "/history",
    name: "History",
    component: History,
    menu: "pelayanan",
    moduleId: 4,
  },
  {
    path: "/history_ihs",
    name: "History IHS",
    component: IhsHistory,
    menu: "pelayanan",
    moduleId: 16,
  },
  {
    path: "/umum",
    name: "Umum",
    component: Umum,
    menu: "pelayanan",
    moduleId: 5,
  },
  {
    path: "/kklp",
    name: "kklp",
    component: Kklp,
    menu: "pelayanan",
    moduleId: 5,
  },
  {
    path: "/gigi",
    name: "Gigi",
    component: Gigi,
    menu: "pelayanan",
    moduleId: 1,
  },
  {
    path: "/perawat",
    name: "Perawat",
    component: Perawat,
    menu: "pelayanan",
    moduleId: 2,
  },
  {
    path: "/FormSehat",
    name: "Surat Sehat",
    component: FormSehat,
    menu: "pelayanan",
    moduleId: 6,
  },
  {
    path: "/FormSakit",
    name: "Surat Sakit",
    component: Sickness,
    menu: "pelayanan",
    moduleId: 7,
  },
  {
    path: "/FormPeriksa",
    name: "Surat Periksa",
    component: FormPeriksa,
    menu: "pelayanan",
    moduleId: 24,
  },
  {
    path: "/FormButaWarna",
    name: "Surat Buta Warna",
    component: FormButaWarna,
    menu: "pelayanan",
    moduleId: 25,
  },
  {
    path: "/FormUploadImage",
    name: "Upload Gambar",
    component: FormUploadImage,
    menu: "pelayanan",
    moduleId: 26,
  },
  {
    path: "/RawatInap",
    name: "Rawat Inap",
    component: RawatInap,
    menu: "pelayanan",
    moduleId: 27,
  },
  {
    path: "/HistoryRanap",
    name: "History Ranap",
    component: HistoryRanap,
    menu: "pelayanan",
    moduleId: 28,
  },
  {
    path: "/PermintaanLab",
    name: "Permintaan Lab",
    component: PermintaanLab,
    menu: "pelayanan",
    moduleId: 8,
  },
  {
    path: "/PemeriksaanLab",
    name: "Pemeriksaan Lab",
    component: PemeriksaanLab,
    menu: "pelayanan",
    moduleId: 9,
  },
  {
    path: "/Resume",
    name: "Resume",
    component: Resume,
    menu: "pelayanan",
    moduleId: 10,
  },
  {
    path: "/Resep",
    name: "Resep",
    component: Resep,
    menu: "pelayananObat",
    moduleId: 11,
  },
  {
    path: "/KB",
    name: "KB",
    component: KB,
    menu: "pelayanan",
    moduleId: 12,
  },
  {
    path: "/KBUlang",
    name: "KB Ulang",
    component: KbUlang,
    menu: "pelayanan",
    moduleId: 19,
  },
  {
    path: "/Caten",
    name: "Caten",
    component: Caten,
    menu: "pelayanan",
    moduleId: 19,
  },
  {
    path: "/SPM",
    name: "SPM",
    component: SPM,
    menu: "pelayanan",
    moduleId: 20,
  },
  {
    path: "/MTBS",
    name: "MTBS",
    component: Mtbs,
    menu: "pelayanan",
    moduleId: 13,
  },
  {
    path: "/RiwayatKehamilan",
    name: "Riwayat Kehamilan",
    component: PregnantHistory,
    menu: "pelayanan",
    moduleId: 14,
  },
  {
    path: "/PemeriksaanKehamilan",
    name: "Pemeriksaan Kehamilan",
    component: Pregnant,
    menu: "pelayanan",
    moduleId: 15,
  },
  {
    path: "/PemeriksaanAnak",
    name: "Pemeriksaan Anak",
    component: Immunization,
    menu: "pelayanan",
    moduleId: 16,
  },
  {
    path: "/PelayananInformasiObat",
    name: "PIO",
    component: DrugInformation,
    menu: "pelayananObat",
    moduleId: 17,
  },
  {
    path: "/DokumentasiKonseling",
    name: "Konseling",
    component: DrugCounseling,
    menu: "pelayananObat",
    moduleId: 18,
  },
  {
    path: "/history",
    name: "History",
    component: History,
    menu: "pelayananObat",
    moduleId: 19,
  },
  {
    path: "/Igd",
    name: "Igd",
    component: Igd,
    menu: "pelayanan",
    moduleId: 19,
  },
  {
    path: "/gtb",
    name: "Grafik Tumbuh Kembang",
    component: GrafikTumbuhKembang,
    menu: "pelayanan",
    moduleId: 20,
  },
  {
    path: "/RiwayatImunisasi",
    name: "Riwayat Imunisasi",
    component: ImmunizationHistory,
    menu: "pelayanan",
    moduleId: 21,
  },
  {
    path: "/pedigree",
    name: "Family History",
    component: Pedigree,
    menu: "pelayanan",
    moduleId: 21,
  },
  {
    path: "/kesehatan-lingkungan",
    name: "Kesehatan Lingkungan",
    component: kesehatanLingkungan,
    menu: "pelayanan",
    moduleId: 22,
  },
  {
    path: "/kajian-awal",
    name: "Kajian Awal",
    component: KajianAwal,
    menu: "pelayanan",
    moduleId: 34,
  },
  {
    path: "/sanitasi",
    name: "Sanitasi",
    component: sanitasi,
    menu: "pelayanan",
    moduleId: 35,
  },
  {
    path: "/sanitasiNew",
    name: "SOAP Sanitasi",
    component: Sanitasi,
    menu: "pelayanan",
    moduleId: 351,
  },
  {
    path: "/kajian-awal-perawat",
    name: "Kajian Awal Perawat",
    component: KajianAwalPerawat,
    menu: "pelayanan",
    moduleId: 40,
  },
  {
    path: "/gizi",
    name: "Gizi",
    component: Gizi,
    menu: "pelayanan",
    moduleId: 37,
  },
  {
    path: "/sdidtk",
    name: "SDIDTK",
    component: Sdidtk,
    menu: "pelayanan",
    moduleId: 38,
  },
  {
    path: "/psikologi",
    name: "Psikologi",
    component: Psikologi,
    menu: "pelayanan",
    moduleId: 39,
  },
  {
    path: "/kulit",
    name: "Kulit",
    component: Kulit,
    menu: "pelayanan",
    moduleId: 41,
  },
  {
    path: "/dbd",
    name: "Import DBD",
    component: Psikologi,
    menu: "pelayanan",
    moduleId: 121,
  },
  {
    path: "/map-dbd",
    name: "Map DBD",
    component: Psikologi,
    menu: "pelayanan",
    moduleId: 123,
  },
  {
    path: "/ilp",
    name: "ILP",
    component: Ilp,
    menu: "pelayanan",
    moduleId: 123,
  },
];

export { routes, modules };
